// Once-per-device flag for the "click the star to place this take on the
// timeline" hint shown at the first generated take (GitHub #1, point 1).
// Expiry, legacy migration and blocked-storage rules live in onceFlag.ts
// (shared with the Welcome and first-upload popups).

import { hasSeenOnceFlag, markOnceFlagSeen } from './onceFlag';

export const STAR_HINT_KEY = 'vs-star-hint-v1';

export function hasSeenStarHint(storage?: Storage): boolean {
  return hasSeenOnceFlag(STAR_HINT_KEY, storage);
}

export function markStarHintSeen(storage?: Storage): void {
  markOnceFlagSeen(STAR_HINT_KEY, storage);
}
